<div class="close">
    <button (click)="closeOverLay()"
            [attr.aria-label]="'BUTTON.CLOSE' | translate">
        <app-svg use="close"
                 aria-hidden="true"></app-svg>
    </button>
</div>
<div class="menu-overlay"
     [attr.animation]="animation">
    <div class="link"
         *ngIf="parent">
        <button (click)="expand(grandparent)"
                [class.is-parent]="parent">
            <app-svg class="chevron"
                     use="chevron-left"
                     aria-hidden="true"></app-svg> {{ 'MENU.GO_BACK' | translate: {title:grandparent?.title || ('MENU.MAIN' | translate)} }}
        </button>
    </div>
    <div class="link"
         *ngFor="let link of list">
        <button (click)="navigateOrExpand(link)"
                class="has-children"
                *ngIf="link?.children?.length > 0">{{ link.title }}
            <app-svg class="chevron"
                     aria-hidden="true"
                     use="chevron-right"></app-svg>
        </button>
        <a [routerLink]="link.link"
           (click)="closeOverLay()"
           *ngIf="!(link?.children?.length > 0)">{{ link.title }}</a>
    </div>
    <div class="link"
         *ngFor="let link of contentList">
        <button class="button"
                (click)="navigateOrExpand(link)"
                class="has-children"
                *ngIf="link?.children?.length > 0">{{ link.title }}
            <app-svg class="chevron"
                     aria-hidden="true"
                     use="chevron-right"></app-svg>
        </button>
        <a class="button"
           [routerLink]="link.link"
           (click)="closeOverLay()"
           *ngIf="!(link?.children?.length > 0)">{{ link.title }}</a>
    </div>
    <ng-container *ngIf="!parent">
        <a class="action"
           (click)="closeOverLay()"
           [routerLink]="action?.link"
           *ngFor="let action of actions">
            <img class="action-img"
                 [use]="action?.image"
                 [query]="{ width: 120, height:120}"
                 aria-hidden="true"
                 *ngIf="action?.image?.focalPoint">
            <app-svg class="action-svg"
                     [use]="action?.image"
                     aria-hidden="true"
                     *ngIf="!action?.image?.focalPoint"></app-svg>
            <span class="action-title">{{ action.title }}</span>
        </a>
    </ng-container>
    <ng-container *ngIf="parent?.link">
        <div class="go-to">
            <button (click)="navigate(parent)">{{ 'MENU.ALL_OF' | translate: { title: parent?.title} }}</button>
            <app-svg class="chevron"
                     use="chevron-right"></app-svg>
        </div>
    </ng-container>
</div>
<ng-template #actionLinks
             let-actions>
    <ng-container *ngFor="let action of actions">
        <ng-container *ngTemplateOutlet="action?.function==null?actionLink:actionButton;context:{$implicit:action}"></ng-container>
    </ng-container>
</ng-template>
<ng-template #menuLinks
             let-links>
    <ng-container *ngFor="let link of links">
        <ng-container *ngTemplateOutlet="link?.children?.length > 1?menuButton:menuLink;context:{$implicit:link}"></ng-container>
    </ng-container>
</ng-template>
<ng-template #actionButton
             let-action>
    <button class="action-button"
            role="menuitem"
            [attr.aria-label]="action?.title"
            (click)="action?.function(); closeOverLay();">
        <app-svg aria-hidden="true"
                 [use]="action?.image"
                 [attr.count]="action?.count | async"
                 *ngIf="!action?.image?.focalPoint"></app-svg>
        <img aria-hidden="true"
             [use]="action?.image"
             [query]="{width: 48, height:48, }"
             [attr.count]="action?.count | async"
             *ngIf="action?.image?.focalPoint">
        <span class="action-text"
              aria-hidden="true"
              *ngIf="action?.hideTitle">{{ action?.title }}</span>
    </button>
</ng-template>
<ng-template #actionLink
             let-action>
    <a class="action-link"
       role="menuitem"
       (click)="closeOverLay()"
       [attr.aria-label]="action?.title"
       [routerLink]="action?.link">
        <app-svg aria-hidden="true"
                 [use]="action?.image"
                 [attr.count]="action?.count | async"
                 *ngIf="!action?.image?.focalPoint"></app-svg>
        <img aria-hidden="true"
             [use]="action?.image"
             [query]="{width: 48, height:48, }"
             [attr.count]="action?.count | async"
             *ngIf="action?.image?.focalPoint">
        <span class="action-text"
              aria-hidden="true"
              *ngIf="action?.hideTitle">{{ action?.title }}</span>
    </a>
</ng-template>
<ng-template #menuButton
             let-link>
    <button class="menu-button"
            role="menuitem"
            (click)="navigateOrExpand(link)">{{link?.title}}</button>
</ng-template>
<ng-template #menuLink
             let-link>
    <a class="menu-link"
       (click)="closeOverLay()"
       role="menuitem"
       [routerLink]="link?.link">{{link?.title}}</a>
</ng-template>
